import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    async getDocuments(patientId, type, params) {
        // type = attachments | letters
        const res = await Axios.get(`${baseURL}patient/${patientId}/${type}`, {
            params: params
        });

        return res.data.response;
    },
    async getCertificates({ type, page, patientId }) {
        const res = await Axios.get(
            `${baseURL}record/certificate/${patientId}/patient`,
            {
                params: {
                    type,
                    page
                }
            }
        );

        return res.data.response;
    },
    async getPDFLetterURI(documentId) {
        const res = await Axios.get(
            `${baseURL}patient/print-letter/${documentId}`
        );

        if (res.data.response.code !== 200) {
            return null;
        }

        return res.data.response.resources.uri;
    },
    async getLetterTemplate() {
        const res = await Axios.get(`${baseURL}account/template/letter`);
        return res.data.response.resources;
    },
    async getAuthor() {
        const res = await Axios.get(`${baseURL}actor/staff`, {
            params: {
                getAll: 1
            }
        });

        return res.data.response.resources;
    },
    async getProvider() {
        const res = await Axios.get(`${baseURL}actor/staff/business/providers`);

        if (res.data.response && res.data.response.resource) {
            return res.data.response.resource.data || [];
        }

        return [];
    },
    async getPatientMedicalNote(patientId) {
        const res = await Axios.get(
            `${baseURL}record/medical-note/${patientId}`
        );

        if (res.data.response) {
            return res.data.response.resources || [];
        }

        return [];
    },
    async saveNewLetter(params = {}) {
        const data = {};
        data.patient_id = params.pid;
        data.client_id = params.cid;
        data.soap_id = params.sid;
        data.template_id = params.template;
        data.recipient_id = params.recipient_id;
        data.title = params.title;
        data.date = params.date;
        data.vet_id = params.vet_id;

        const res = await Axios.post(`${baseURL}patient/letters`, data);
        if (res.data.response) {
            return res.data.response;
        }
        return null;
    },
    async updateLetter(params = {}) {
        const data = {};
        data.id = params.id;
        data.patient_id = params.pid;
        data.client_id = params.cid;
        data.soap_id = params.sid;
        data.template_id = params.template;
        data.recipient_id = params.recipient_id;
        data.title = params.title;
        data.date = params.date;
        data.vet_id = params.vet_id;

        const res = await Axios.post(`${baseURL}patient/letters`, data);
        if (res.data.response) {
            return res.data.response;
        }
        return null;
    },
    async lockLetter(letterId) {
        const res = await Axios.get(
            `${baseURL}patient/lock-letter/${letterId}`
        );

        if (res.data.response) {
            return res.data.response || [];
        }
    },
    async deleteLetter(letterId) {
        const res = await Axios.delete(`${baseURL}patient/letter/${letterId}`);
        if (res.data.response) {
            return res.data.response || [];
        }
    },
    saveSigniture(params) {
        return Axios.post(
            `${baseURLci}common/signature/saveSignature`,
            params
        ).then(response => response.data);
    },
    clearSigniture(params) {
        return Axios.post(
            `${baseURLci}common/signature/clearSignature`,
            params
        ).then(response => response.data);
    },
    async deleteDocument(type, id) {
        // type = letter | attachment
        const route = `${baseURLci}patient/${type}/remove`;
        await Axios.get(route, {
            params: { id }
        });
    },
    async getLabAttachment({ patientId, labId, page }) {
        const res = await Axios.get(
            `${baseURL}lab/attachments/${labId}/${patientId}`,
            {
                params: { page }
            }
        );

        return res.data.response;
    },
    getTabCounts(patientId) {
        return Axios.get(
            `${baseURL}record/patient-document/${patientId}/tab-count`
        ).then(response => {
            if (response && response.data && response.data.response) {
                return response.data.response;
            }
            return null;
        });
    },
    async getWebforms(params) {
        const res = await Axios.get(`${baseURL}patient/webform`, {
            params: params
        });
        if (res && res.data) {
            return res.data.response;
        } else {
            return null;
        }
    }
};
